"use strict";

exports.__esModule = true;
exports.getGoogleApiURL = void 0;
var getGoogleApiURL = exports.getGoogleApiURL = function getGoogleApiURL(opts) {
  if (opts === void 0) {
    opts = {};
  }
  var _opts = opts,
    apiKey = _opts.apiKey;
  var libraries = opts.libraries || [];
  var _opts2 = opts,
    client = _opts2.client;
  var URL = 'https://maps.googleapis.com/maps/api/js';

  // Versioning Documentation
  // https://developers.google.com/maps/documentation/javascript/versions
  var version = '3.49';
  var language = opts.language || null;
  var url = function url() {
    var params = {
      key: apiKey,
      callback: 'CALLBACK_NAME',
      libraries: libraries.join(','),
      client: client,
      v: version,
      channel: null,
      language: language
    };

    // TODO: Look into why only this region/language combo
    // breaks initial map on initial load
    if (language === 'en' && opts.region === 'th' || language === 'ar' && opts.region === 'om') {
      params.region = opts.region;
    }
    var paramStr = Object.keys(params).filter(function (k) {
      return !!params[k];
    }).map(function (k) {
      return k + "=" + params[k];
    }).join('&');
    return URL + "?" + paramStr;
  };
  return url();
};